<form [formGroup]="contactForm">
  <app-form-group [form]="contactForm" [controls]="controls" [center]="center"></app-form-group>
  <button appButton [loading]="saving" type="submit" class="btn btn-light-blue" [ngClass]="{center: center}"
    (click)="send(contactForm.value)" [disabled]="!contactForm.valid">Send</button>
</form>
